<script setup lang="ts">
  /**
   * Progress 进度条组件
   * @description
   * 1. 用于展示任务的完成进度
   * 2. 基于 reka-ui 的 ProgressRoot 和 ProgressIndicator 构建
   * 3. 支持自定义样式和进度值
   */
  import type { ProgressRootProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { ProgressIndicator, ProgressRoot } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'

  const props = withDefaults(
    defineProps<ProgressRootProps & { class?: HTMLAttributes['class'] }>(),
    {
      modelValue: 0,
    },
  )

  const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <ProgressRoot
    v-bind="delegatedProps"
    :class="cn('relative h-2.5 w-full overflow-hidden rounded-6xl bg-common-level2', props.class)"
  >
    <ProgressIndicator
      class="relative h-full w-full flex-1 bg-brand-blue1 transition-all rounded-6xl"
      :style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
    >
      <slot name="indicator" :model-value="props.modelValue ?? 0" />
    </ProgressIndicator>
  </ProgressRoot>
</template>
